import React from 'react';
import { useSelector } from 'react-redux';

import FaqContainer from 'components/AiAssist/FAQ/FaqContainer';
import TrustSection from 'components/Core/TrustSection/TrustSection';
import FaasWidget from 'components/Experiments/Faas/FaasWidget';
import ContactMerchantCard from 'components/Shared/Contact/MerchantCard/ContactMerchantCard';
import PreviewCard from 'components/Shared/PreviewCard/PreviewCard';
import Separator from 'components/Shared/Separator/Separator';
import { companyInfoSelectors } from 'store/companyInfo/selectors';
import { insightSelectors } from 'store/insight/selectors';
import { saleSelectors } from 'store/sale/selectors';
import { RootState } from 'store/store';
import { breakpoints } from 'styles/cp';
import { TXN_MAP } from 'types/constants';

// No props needed - SidePanel is fully self-contained
const SidePanel: React.FC = () => {
  // Connect directly to Redux store using selectors
  const sale = useSelector((state: RootState) => state.sale);
  const insight = useSelector((state: RootState) => state.insight);
  const config = useSelector((state: RootState) => state.config);
  const companyInfo = useSelector((state: RootState) => state.companyInfo);

  // Get transaction type once
  const transactionType = saleSelectors.typeSelector(sale);

  const renderFAQ = () => {
    // Only show FAQ for invoice pages
    const isInvoice = transactionType === TXN_MAP.TYPES.INVOICE;

    if (isInvoice) {
      return (
        <>
          <FaqContainer />
          <Separator height={15} />
        </>
      );
    }
    return null;
  };

  return (
    <>
      <aside className="side-panel">
        <FaasWidget
          insight={insight}
          shouldShowFaasWidget={insightSelectors.isValidFinancingOfferSelector(insight)}
        />
        <PreviewCard />
        <Separator height={15} />
        <ContactMerchantCard
          companyAddress={companyInfoSelectors.addressSelector(companyInfo) || undefined}
          companyEmail={companyInfoSelectors.emailSelector(companyInfo) || ''}
          companyPhone={companyInfoSelectors.phoneSelector(companyInfo) || ''}
          companyWebAddr={companyInfoSelectors.webAddrSelector(companyInfo) || ''}
          number={saleSelectors.referenceNumberSelector(sale)}
        />
        <Separator height={15} />
        {renderFAQ()}
        <TrustSection cdn={config.endpoints?.cdn || ''} />
        <style jsx>{`
          .side-panel {
            width: 35%;
            padding-top: 15px;
            padding-left: 20px;

            @media screen and (max-width: ${breakpoints.md}) {
              display: none;
            }
          }
        `}</style>
      </aside>
    </>
  );
};

export default SidePanel;
